import mock from "./mock";
import "./autoComplete/autoComplete";
import "./navbar/navbarSearch";

mock.onAny().passThrough();
